/* eslint-disable react/prop-types,react/destructuring-assignment,
 react/no-array-index-key, jsx-a11y/no-noninteractive-element-interactions */
// Copyright (c) 2019 Deere & Company

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

export const DropdownPopover = (props) => (
    <div className="dropdown-popover">
        <ul className="dropdown-menu">
            {Array.isArray(props.children) ? (
                props.children.map((item, index) => (
                    <li className="dropdown-item" key={index} onClick={props.onMenuItemClick}>
                        {item}
                    </li>
                ))
            ) : (
                <li className="dropdown-item" onClick={props.onMenuItemClick}>
                    {props.children}
                </li>
            )}
            <li>
                <button
                    type="button"
                    className="button-text logout-button"
                    onClick={props.logout}
                >
                    <FormattedMessage id="SIGN_OUT" />
                </button>
            </li>
        </ul>
    </div>
);

DropdownPopover.propTypes = {
    children: PropTypes.node.isRequired,
    onMenuItemClick: PropTypes.func.isRequired,
};
